import React from 'react';
import {map} from 'lodash';
import ExampleBlock from './example-block';
import styles from './guidelines.module.scss';
import PrimaryLogo from 'shared/img/primary-logo.svg';
import WhiteLogo from 'shared/img/primary-logo-white.svg';
import BlueLogo from 'shared/img/primary-logo-blue.svg';
import StackedLogo from 'shared/img/primary-stacked-logo-blue.svg';
import IncorrectRedLogo from 'assets/images/aptitude/incorrect-logo-red.svg';
import IncorrectBadgeOnly from 'assets/images/aptitude/incorrect-logo-symbol-only.svg';
import CmykBlueLogo from 'assets/images/aptitude/cmyk-logo-blue.svg';
import ProhibitedSymbol from 'assets/images/aptitude/prohibited-symbol.svg';
import Icon from 'shared/components/icon';

const GUIDELINES = [
  {
    background: 'violet',
    text: "Don't place the Raise Me logo on colors that are not our brand blue.",
    children: <PrimaryLogo width={300} />,
    type: false,
  },
  {
    background: 'blue',
    text: 'Do place the Raise Me logo on the Raise Me blue background when possible.',
    children: <PrimaryLogo width={300} />,
    type: true,
  },
  {
    background: 'image',
    text: "Don't use a Raise Me logo containing a blue icon mark over another image.",
    children: <PrimaryLogo width={300} />,
    type: false,
  },
  {
    background: 'image',
    text: 'Do use the white Raise Me logo.',
    children: <WhiteLogo width={300} height={56} />,
    type: true,
  },
  {
    text: "Don't contain the Raise Me logo in any shapes or objects.",
    children: (
      <span className={styles.guidelineBackground}>
        <PrimaryLogo width={300} />
      </span>
    ),
    type: false,
  },
  {
    text: 'Do use either the horizontal or stacked Raise Me logo in blue or white to fit your needs.',
    children: <BlueLogo width={300} />,
    type: true,
  },
  {
    text: "Don't change the color of the icon mark or word mark.",
    children: <IncorrectRedLogo width={300} height={64} />,
    type: false,
  },
  {
    text: 'Do use the blue or white Raise Me logo.',
    children: <BlueLogo width={300} />,
    type: true,
  },
  {
    text: "Don't remove the word mark from the horizontal or stacked versions of the Raise Me logo.",
    children: <IncorrectBadgeOnly width={150} height={153} />,
    type: false,
  },
  {
    text: 'Do use either the horizontal or stacked Raise Me logo to fit your constraints.',
    children: <StackedLogo width={150} />,
    type: true,
  },
  {
    text: "Don't use the RGB or Web Raise Me logo for print.",
    children: <BlueLogo width={300} />,
    type: false,
  },
  {
    text: 'Do use the CMYK Raise Me logo for print.',
    children: <CmykBlueLogo width={300} />,
    type: true,
  },
];

export default class Guidelines extends React.Component {
  text = (text, type) => (
    <span className={styles.guidelineContainer}>
      <Icon
        iconType={type ? 'check-r' : 'times-r'}
        className={type ? styles.trueIcon : styles.falseIcon}
      />
      {text}
    </span>
  );

  render() {
    return (
      <>
        {map(GUIDELINES, (guideline, i) => {
          const {background, text, children, type} = guideline;
          return (
            <ExampleBlock
              className={styles.exampleBlock}
              background={background}
              text={this.text(text, type)}
              key={`block-${i}`}
            >
              {children}
              {!type && <ProhibitedSymbol className={styles.prohibited} width={256} />}
            </ExampleBlock>
          );
        })}
      </>
    );
  }
}
